import React from 'react';
import { Form } from 'react-bootstrap';

import PropTypes from 'prop-types';

class Forms extends React.Component {
    /**
     * 기본 데이터 변경시
     * @param  e
     */
    onChange = e => {
        if (e.target.value.length > this.props.maxLengh) {
            // return;
            e.target.value = e.target.value.substr(0, this.props.maxLengh);
        }
        if (this.props.onChange !== undefined) {
            this.props.onChange(e);
        }
    };

    render() {
        return (
            <Form.Group>
                <Form.Label>{this.props.title}</Form.Label>
                <Form.Control
                    as="textarea"
                    rows="5"
                    value={this.props.value === null ? '' : this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                />
            </Form.Group>
        );
    }
}

Forms.defaultProps = {
    title: '',
    type: 'text',
    value: '',
    placeholder: '',
    disabled: false,
    parent: undefined,
    name: undefined,
};

Forms.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
};

export default Forms;
